import AccountingCoordinator from "../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Coordinator for the search the ledger document.
 */
export default class SearchDocumentCoordinator extends AccountingCoordinator {}
